import { ActionContext, Module } from 'vuex'
import { ConversationAiResellingService, ProductRebillingService } from '../services'
import { ConversationAiState, RootState } from '../store/state_models'

import get from "lodash-es/get"
import set from "lodash-es/set"

export const conversationAi: Module<ConversationAiState, RootState> = {
  namespaced: true,
  state: {
    isConversationAiEnabled: undefined,
    trialConversationList: {},
    aiSettings: {},
    locationConversationAiEnabling: {},
    aiEmployeeSettings: {},
  },
  getters: {
    getTrialConversations: (state: ConversationAiState) => {
      return (locationId: string,agentId: string) =>
        get(state.trialConversationList, [locationId,agentId])
    },
    getAiSettings: (state: ConversationAiState) => {
      return (locationId: string) => get(state.aiSettings, locationId)
    },
    getAIEmployeeSettings: (state: ConversationAiState) => {
      return (params: { locationId: string; employeeId: string }) => {
        return get(state.aiEmployeeSettings, params.locationId)?.[params.employeeId]
      }
    },
  },
  mutations: {
    updateConversationList: (
      state: ConversationAiState,
      params: { message: { [key: string]: any }; locationId: string, agentId: string,  thumbVote?:string, index?:any, selectedIntent?:string }
      ) => {
        if (state.trialConversationList[params.locationId]) {
          if(state.trialConversationList[params.locationId][params.agentId]){
            if(params.thumbVote){
              state.trialConversationList[params.locationId][params.agentId].messageList[params.index]['thumbVote']= params.thumbVote
            } 
            if(params.message) {
              state.trialConversationList[params.locationId][params.agentId].messageList.push(params.message)
            }
            if(params.selectedIntent){
              state.trialConversationList[params.locationId][params.agentId].selectedIntent = params.selectedIntent
            }
          }
          else{
            state.trialConversationList[params.locationId][params.agentId] = {messageList: [], selectedIntent: ''}
            if(params.message)
              state.trialConversationList[params.locationId][params.agentId].messageList.push(params.message)
            if(params.selectedIntent)
              state.trialConversationList[params.locationId][params.agentId].selectedIntent = params.selectedIntent
          }
        } else {
          state.trialConversationList = set(
            state.trialConversationList,
            params.locationId,
            {[params.agentId]: {messageList: [], selectedIntent: ''}}
          )
          if(params.message)
            state.trialConversationList[params.locationId][params.agentId].messageList.push(params.message)
          if(params.selectedIntent)
            state.trialConversationList[params.locationId][params.agentId].selectedIntent = params.selectedIntent
        }
  
      },
    resetConversationList: (
      state: ConversationAiState,
      params: { locationId: string, agentId: string }
    ) => {
      state.trialConversationList[params.locationId][params.agentId].messageList = []
      state.trialConversationList[params.locationId][params.agentId].selectedIntent = ''
    },
    updateConversationAi:(state: ConversationAiState,
      payload: { value:boolean }) => {
        state.isConversationAiEnabled = payload.value
    },
    updateAiSettings: (state: ConversationAiState,
      payload: {data: any, locationId: string}) => {
        state.aiSettings[payload.locationId] = payload.data
        window.localStorage.conversationAISetting = JSON.stringify(payload.data)
    },
    updateAIEmployeeSettings: (state: ConversationAiState, payload: { data: any; locationId: string }) => {
      state.aiEmployeeSettings[payload.locationId] = {
        ...state.aiEmployeeSettings[payload.locationId],
        ...payload.data,
      }
    },
    updateLocationWiseEnabling: (state:ConversationAiState, payload:{locationId: string, enabled: boolean}) => {
      state.locationConversationAiEnabling[payload.locationId] = payload.enabled
    }
  },
  actions: {
    addTrialMessage: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { message: { [key: string]: any }; locationId: string; agentId: string; }
    ) => {
      context.commit('updateConversationList', payload)
    },
    resetConversation: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { locationId: string, agentId: string; }
    ) => {
      context.commit('resetConversationList', payload)
    },
    changeConversationAiEnabling: (context: ActionContext<ConversationAiState, RootState>,
      payload: { value:boolean }) =>{
        context.commit('updateConversationAi', payload)
      },
    updateTrialAuditing: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { thumbVote: string, agentId: string; }    // 'up' 'down'
    ) => {
      context.commit('updateConversationList', payload)
    },
    updateSelectedIntent: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { selectedIntent: string, agentId: string; }
    ) => {
      context.commit('updateConversationList', payload)
    },

    updateConversationsAI: (
      context: ActionContext<ConversationAiState, RootState>,
      payload: { data: any, locationId: string }
    ) => {
      context.commit('updateAiSettings', payload)
    }, 
    updateAIEmployeeSettings: (context: ActionContext<ConversationAiState, RootState>,
      payload: { data: any, locationId: string, employeeId: string }) => {
        context.commit('updateAIEmployeeSettings', payload)
      },
    changedLocationEnabling :( context: ActionContext<ConversationAiState, RootState>,
      payload: { locationId: string, enabled: boolean }) => {
        context.commit('updateLocationWiseEnabling',payload)
      },
    async getProduct() {
      try {
        const res = await ConversationAiResellingService.getProductConfiguration()
        return Promise.resolve(res)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async getConversationsAIProduct() {
      try {
        const res = await ConversationAiResellingService.getConversationsAIProductConfiguration()
        return Promise.resolve(res)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async getCompanySubscriptions(context: ActionContext<ConversationAiState, RootState>) {
      try {
        const companyId =  context.rootState?.company.company.id as string
        const res = await ConversationAiResellingService.getCompanySubscriptions(companyId)

        const locationSubscriptions = res.filter((item) => item.productCode === "CONVERSATIONS_AI")
        return Promise.resolve(locationSubscriptions)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async getLocationSubscriptions(context: ActionContext<ConversationAiState, RootState>) {
      try {
        const locationId = context.rootState?.locations.currentLocation.id as string
        const res = await ConversationAiResellingService.getLocationSubscriptions(locationId)
        const locationSubscriptions = res.filter((item) => item.productCode === "CONVERSATIONS_AI" && item.paymentStatus == "COMPLETE")

        return Promise.resolve(locationSubscriptions)
      } catch(error) {
        return Promise.reject(error)
      }
    },
    async fetchConversationAIOptInForLocation(context: ActionContext<ConversationAiState, RootState>, payload: { entityId: string }) {
      const entityId = payload.entityId
      if (!entityId) return;
      const isAIEnabledForLocation = context.state?.locationConversationAiEnabling[entityId];
      if (isAIEnabledForLocation !== undefined && isAIEnabledForLocation !== null) {
        return isAIEnabledForLocation;
      }
      const response = await ProductRebillingService.getByProduct(entityId, 'LOCATION', 'conversationAI', true);
      if (response) {
        await context.commit('updateLocationWiseEnabling', { locationId: entityId, enabled: response.productOptIn });
        return response.productOptIn;
      }
      return true;
    }
  },
}
